import { omitBy } from "lodash-es";

type WithoutUndefinedValues<T extends object> = Pick<
    T,
    { [K in keyof T]: undefined extends T[K] ? never : K }[keyof T]
>;

export function withoutUndefinedValues<T extends object>(object: T): WithoutUndefinedValues<T> {
    return omitBy<T>(object, (value) => value === undefined) as never;
}
